import auth from '../../middlewares/auth';

export const wowzaLicenseRoutes = [
  {
    path: '/wowza-licenses',
    component: () =>
      import(
        /* webpackChunkName: "wowza-licenses" */ '../../views/wowza_licenses/WowzaLicense'
      ),
    name: 'wowza-licenses',
    meta: {
      middleware: [auth],
      requiredPermissions: ['wowza-license-manage'],
    },
  },
  {
    path: '/wowza-license/:id',
    component: () =>
      import(
        /* webpackChunkName: "wowza-licenses" */ '../../views/wowza_licenses/WowzaLicenseForm'
      ),
    name: 'update-wowza-license',
    meta: {
      middleware: [auth],
      requiredPermissions: ['wowza-license-manage'],
    },
  },
  {
    path: '/create-wowza-license',
    component: () =>
      import(
        /* webpackChunkName: "wowza-licenses" */ '../../views/wowza_licenses/WowzaLicenseForm'
      ),
    name: 'create-wowza-license',
    meta: {
      middleware: [auth],
      requiredPermissions: ['wowza-license-manage'],
    },
  },
];
